<template>
  <div class="detail-page">
    <BreadCrumb :data="breadcrumb" :title="'课程列表管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <div v-show="isEditting == false" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="form-content-img">
          <img v-if="seriesDetail.cover_image" :src="seriesDetail.cover_image" />
          <img v-else src="../../../../static/image/no-img.png" alt="" />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文标题</h4>
            <span>{{ seriesDetail.chinese_name }}</span>
          </li>
          <li class="exclusive">
            <h4>英文标题</h4>
            <span>{{ seriesDetail.english_name }}</span>
          </li>
          <li class="exclusive">
            <h4>中文简介</h4>
            <span v-if="seriesDetail.chinese_introduce != null">{{
              seriesDetail.chinese_introduce
            }}</span>
            <span v-if="seriesDetail.chinese_introduce == null">暂无</span>
          </li>
          <li class="exclusive">
            <h4>英文简介</h4>
            <span v-if="seriesDetail.english_introduce != null">{{
              seriesDetail.english_introduce
            }}</span>
            <span v-if="seriesDetail.english_introduce == null">暂无</span>
          </li>
          <li class="one-third">
            <h4>是否展示</h4>
            <el-switch
              v-model="seriesDetail.drop_down_flag"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
          <li class="one-third" v-if="seriesDetail.drop_down_flag==1">
            <h4>系列名字</h4>
             <span>{{ seriesDetail.short_name }}</span>
          </li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="seriesDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
          
        </ul>
      </div>
    </div>
    <!-- 修改课程系列详情基本信息页 -->
    <div v-show="isEditting == true" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <UploadImage
          :img="seriesDetail.cover_image"
          :width="390"
          :height="240"
          @getUploadImage="getUploadImage"
          class="form-content-img"
        ></UploadImage>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文标题<span>*</span></h4>
            <el-input v-model="seriesDetail.chinese_name"></el-input>
          </li>
          <li class="exclusive">
            <h4>英文标题<span>*</span></h4>
            <el-input v-model="seriesDetail.english_name"></el-input>
          </li>
          <li class="exclusive">
            <h4>中文简介<span>*</span></h4>
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="seriesDetail.chinese_introduce"
            >
            </el-input>
          </li>

          <TranslateText
            class="translate-btn"
            v-if="isEditting"
            :chinese="seriesDetail.chinese_introduce"
            :english="seriesDetail.english_introduce"
            @returnTranslate="returnTranslate"
          />
          <li class="exclusive">
            <h4>英文简介<span>*</span></h4>
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="seriesDetail.english_introduce"
            >
            </el-input>
          </li>
           <li class="one-third">
            <h4>是否展示</h4>
            <el-switch
              v-model="seriesDetail.drop_down_flag"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </li>
           <li class="one-third" v-if='seriesDetail.drop_down_flag==1'>
            <h4>系列名字</h4>
            <el-input
              placeholder="请输入内容"
              v-model="seriesDetail.short_name"
            >
            </el-input>
          </li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="seriesDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </li>
          
        </ul>
      </div>

    </div>
     <SaveGroup
        :isEditting="isEditting"
        @cancelUpdate="cancelUpdate"
        @save="save"
        @recover="recover"
        @view="view"
        @cancelAdd="cancelAdd"
        @add="add"
      />
    <!-- 课程系列表单 -->
    <div class="pc-series-table" v-if="$route.query.method == 'update'">
      <SeriesTable/>
    </div>
  </div>
</template>
<script>
import SaveGroup from "../../componentSet/SaveGroup.vue";
import UploadImage from "../../componentSet/uploadImage.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import {
  addLectureSeries_Api,
  getLectureSeries_Api,
  updateLectureSeries_Api,
} from "../../../apis/lecture.api";

import SeriesTable from "./components/SeriesTable";
import TranslateText from "../../componentSet/TranslateText.vue";

export default {
  components: {
    SaveGroup,
    UploadImage,
    BreadCrumb,
    SeriesTable,
    TranslateText,
  },
  data() {
    return {
      isEditting: true,
      seriesDetail: {},
    };
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "课程列表", link: "/admin/lecture" },
        { name: "" + this.seriesDetail.chinese_name, link: "" },
      ];
    },
  },
   mounted() {
     console.log(this.$route.query.id)
    if (this.$route.query.method == "update") {
      this.seriesDetail.id = this.$route.query.id;
      this.getSeriesDetail();
    }

  },
  methods: {
    returnTranslate(data,flag){
      flag == 1? this.seriesDetail.english_introduce = data:this.seriesDetail.chinese_introduce = data
      console.log(data)
      console.log(flag)

    },
    getUploadImage(img_url){
    this.seriesDetail.cover_image = img_url
    },
    getSeriesDetail(hint) {
      getLectureSeries_Api(this.seriesDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        this.seriesDetail = res.data;
        console.log(this.seriesDetail)
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getSeriesDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getSeriesDetail("恢复成功");
    },
    view() {
      window.open(
        "http://wupen.org/lectures/topic/" + this.$route.query.id,
        "_blank"
      );
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.seriesDetail);
      if (!formattedData) {
        return;
      } else {
        addLectureSeries_Api(formattedData)
          .then((res) => {
            this.seriesDetail = res.data;
            this.isEditting = false;
            this.getSeriesDetail();
            this.$router.push({
              path: "/admin/seriesdetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.seriesDetail);
      console.log(this.seriesDetail)
      console.log(formattedData)
      if (!formattedData) {
        return;
      } else {
        updateLectureSeries_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getSeriesDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    edit() {
      this.isEditting = true;
    },
    validateForm(formData) {
      //表单校验
      if (!formData.chinese_name || !formData.english_name) {
        this.$global.error(this, "请输入中英文标题");
        return false;
      }
      formData.series_id = formData.id 
      return formData;
    },
 
  },
};
</script>

<style scoped lang="scss">
.form-content-img {
  width: 391px;
  height: 220px;
}
.translate-btn{
  margin-top:10px !important;
  margin-bottom:30px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/lecture/SeriesDetail.vue